import { render, staticRenderFns } from "./Blogs copy.vue?vue&type=template&id=a7268d4c&scoped=true&"
import script from "./Blogs copy.vue?vue&type=script&lang=js&"
export * from "./Blogs copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7268d4c",
  null
  
)

component.options.__file = "Blogs copy.vue"
export default component.exports